const SR_ONLY_CLASS = 'sr-only';

type AttributesObject = { [key: string]: string };

const makeElementHtml = ({ tagName, content, attrs = {} }: { tagName: string, content: string, attrs: AttributesObject }) => {
  const attributes = Object.entries(attrs)
    .map(([name, value]) => `${name}="${value}"`)
    .join(' ');

  return `<${tagName} ${attributes}>${content}</${tagName}>`;
};

const srOnlyElement = (tagName: string, content: string, attrs: AttributesObject = {}) => {
  // Replace any leading or trailing whitespace with a non-breaking space
  const replacedContent = content.replace(/^\s+|\s+$/gi, '&nbsp;');

  return makeElementHtml({
    tagName,
    content: replacedContent,
    attrs: { ...attrs, class: attrs.class ? `${SR_ONLY_CLASS} ${attrs.class}` : SR_ONLY_CLASS },
  });
};

const srOnlySpan = (content: string, attrs: AttributesObject = {}) => srOnlyElement('span', content, attrs);

export {
  srOnlyElement,
  srOnlySpan,
};
